// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PredistributionDetail_container__IseH6 {
    animation: PredistributionDetail_init__c23hI 1s;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    font-size: 16px;
  }
  
  /*---Title---*/
  .PredistributionDetail_container__IseH6 .PredistributionDetail_titleContainer__10Jww {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  
  .PredistributionDetail_container__IseH6 .PredistributionDetail_titleContainer__10Jww .PredistributionDetail_title__IjWfP {
    width: 95%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .PredistributionDetail_container__IseH6 .PredistributionDetail_titleContainer__10Jww .PredistributionDetail_title__IjWfP h4 {
    text-align: center;
    font-size: 1.5rem;
    font-family: Roboto, sans-serif;
    font-weight: 300;
    margin-right: 20px;
  }
  
  .PredistributionDetail_container__IseH6 .PredistributionDetail_titleContainer__10Jww .PredistributionDetail_title__IjWfP .PredistributionDetail_chip__j0KTy {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1rem;
    border-radius: 10px;
    width: 20rem;
    height: 2.5rem;
  }
  
  .PredistributionDetail_container__IseH6 .PredistributionDetail_titleContainer__10Jww .PredistributionDetail_arrow__MQw90 {
    transition: 0.3s;
  }
  
  .PredistributionDetail_container__IseH6 .PredistributionDetail_titleContainer__10Jww .PredistributionDetail_arrow__MQw90:hover {
    transition: 0.3s;
    scale: 1.05;
    background-color: rgba(0, 0, 0, 0.05);
    border-radius: 100%;
    cursor: pointer;
  }
  
  .PredistributionDetail_container__IseH6 .PredistributionDetail_data__3jd0P {
    margin-bottom: 10px;
    margin-top: 2rem;
  }
  
  .PredistributionDetail_container__IseH6 .PredistributionDetail_data__3jd0P .PredistributionDetail_accordion__ku9ZT {
    width: 100%;
    margin-bottom: 20px;
  }
  
  .PredistributionDetail_container__IseH6 .PredistributionDetail_data__3jd0P .PredistributionDetail_dataContainer__n-e5h {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    align-items: center;
    background-color: white;
    border-radius: 0 0 10px 10px;
    box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);
    padding-bottom: 30px;
  }
  
  .PredistributionDetail_container__IseH6 .PredistributionDetail_data__3jd0P .PredistributionDetail_dataContainer__n-e5h .PredistributionDetail_item__DH69O {
    margin-top: 20px;
    width: 200px;
  }
  
  .PredistributionDetail_container__IseH6 .PredistributionDetail_data__3jd0P .PredistributionDetail_dataContainer__n-e5h .PredistributionDetail_item__DH69O h3 {
    font-size: 1.2rem;
    margin: 0;
    margin-bottom: 10px;
    font-weight: 300;
    font-family: Roboto, sans-serif;
  }
  
  .PredistributionDetail_container__IseH6 .PredistributionDetail_data__3jd0P .PredistributionDetail_dataContainer__n-e5h .PredistributionDetail_item__DH69O p {
    font-size: 1rem;
    margin: 0;
    font-weight: 500;
    font-family: Roboto, sans-serif;
  }
  
  /*---Información---*/
  .PredistributionDetail_container__IseH6 .PredistributionDetail_dataContainer__n-e5h .PredistributionDetail_tableContainer__oih8n {
    border-radius: 10px;
    margin-bottom: 50px;
    box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);
  }
  
  .PredistributionDetail_container__IseH6 .PredistributionDetail_loader__yWDZo {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 30px;
  }
  
  .PredistributionDetail_container__IseH6 .PredistributionDetail_gameName__28MhH {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 1.3rem;
    font-weight: 300;
  }
  
  @keyframes PredistributionDetail_init__c23hI {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }`, "",{"version":3,"sources":["webpack://./src/components/Pages/ProcessFiles/PreDistributionTelekino/Detail/PredistributionDetail.module.css"],"names":[],"mappings":"AAAA;IACI,+CAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;EACjB;;EAEA,cAAc;EACd;IACE,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,+BAA+B;IAC/B,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,qCAAqC;IACrC,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,6BAA6B;IAC7B,mBAAmB;IACnB,uBAAuB;IACvB,4BAA4B;IAC5B,8CAA8C;IAC9C,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,SAAS;IACT,mBAAmB;IACnB,gBAAgB;IAChB,+BAA+B;EACjC;;EAEA;IACE,eAAe;IACf,SAAS;IACT,gBAAgB;IAChB,+BAA+B;EACjC;;EAEA,oBAAoB;EACpB;IACE,mBAAmB;IACnB,mBAAmB;IACnB,8CAA8C;EAChD;;EAEA;IACE,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE;MACE,UAAU;IACZ;IACA;MACE,UAAU;IACZ;EACF","sourcesContent":[".container {\n    animation: init 1s;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: 20px;\n    font-size: 16px;\n  }\n  \n  /*---Title---*/\n  .container .titleContainer {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n  }\n  \n  .container .titleContainer .title {\n    width: 95%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  \n  .container .titleContainer .title h4 {\n    text-align: center;\n    font-size: 1.5rem;\n    font-family: Roboto, sans-serif;\n    font-weight: 300;\n    margin-right: 20px;\n  }\n  \n  .container .titleContainer .title .chip {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 1rem;\n    border-radius: 10px;\n    width: 20rem;\n    height: 2.5rem;\n  }\n  \n  .container .titleContainer .arrow {\n    transition: 0.3s;\n  }\n  \n  .container .titleContainer .arrow:hover {\n    transition: 0.3s;\n    scale: 1.05;\n    background-color: rgba(0, 0, 0, 0.05);\n    border-radius: 100%;\n    cursor: pointer;\n  }\n  \n  .container .data {\n    margin-bottom: 10px;\n    margin-top: 2rem;\n  }\n  \n  .container .data .accordion {\n    width: 100%;\n    margin-bottom: 20px;\n  }\n  \n  .container .data .dataContainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-evenly;\n    align-items: center;\n    background-color: white;\n    border-radius: 0 0 10px 10px;\n    box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);\n    padding-bottom: 30px;\n  }\n  \n  .container .data .dataContainer .item {\n    margin-top: 20px;\n    width: 200px;\n  }\n  \n  .container .data .dataContainer .item h3 {\n    font-size: 1.2rem;\n    margin: 0;\n    margin-bottom: 10px;\n    font-weight: 300;\n    font-family: Roboto, sans-serif;\n  }\n  \n  .container .data .dataContainer .item p {\n    font-size: 1rem;\n    margin: 0;\n    font-weight: 500;\n    font-family: Roboto, sans-serif;\n  }\n  \n  /*---Información---*/\n  .container .dataContainer .tableContainer {\n    border-radius: 10px;\n    margin-bottom: 50px;\n    box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);\n  }\n  \n  .container .loader {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: 30px;\n  }\n  \n  .container .gameName {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    font-size: 1.3rem;\n    font-weight: 300;\n  }\n  \n  @keyframes init {\n    0% {\n      opacity: 0;\n    }\n    100% {\n      opacity: 1;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `PredistributionDetail_container__IseH6`,
	"init": `PredistributionDetail_init__c23hI`,
	"titleContainer": `PredistributionDetail_titleContainer__10Jww`,
	"title": `PredistributionDetail_title__IjWfP`,
	"chip": `PredistributionDetail_chip__j0KTy`,
	"arrow": `PredistributionDetail_arrow__MQw90`,
	"data": `PredistributionDetail_data__3jd0P`,
	"accordion": `PredistributionDetail_accordion__ku9ZT`,
	"dataContainer": `PredistributionDetail_dataContainer__n-e5h`,
	"item": `PredistributionDetail_item__DH69O`,
	"tableContainer": `PredistributionDetail_tableContainer__oih8n`,
	"loader": `PredistributionDetail_loader__yWDZo`,
	"gameName": `PredistributionDetail_gameName__28MhH`
};
export default ___CSS_LOADER_EXPORT___;
